import { __ } from "@wordpress/i18n";
import { 
	useBlockProps, 
	InspectorControls,
	__experimentalUseBorderProps as useBorderProps,
	__experimentalUseColorProps as useColorProps,
	__experimentalGetSpacingClassesAndStyles as useSpacingProps
} from "@wordpress/block-editor";
import { 
	Panel, 
	PanelBody, 
	RangeControl 
} from "@wordpress/components";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit(props) {
	const { attributes, setAttributes } = props;
	const borderProps = useBorderProps( attributes );
	const colorProps = useColorProps( attributes );
	const spacingProps = useSpacingProps( attributes );
	const customStyle = {
		height: `${attributes.height}px`,
		width: `${attributes.width}px`,
	}

	const separatorStyle = {
		...borderProps.style, // Default border styles
		...colorProps.style,  // Default color styles
		...spacingProps.style,  // Default spacing styles
		...customStyle,
	};

	function setOption(key, value) {
		setAttributes({ [key]: value });
	}

	return (
		<div {...useBlockProps({ className: "wpopus-advanced-separator"})}
			style = { separatorStyle }
		>
			<InspectorControls key="setting">
				<Panel>
					<PanelBody
						title={__("Advanced Separator Settings", "wpopus")}
						initialOpen={true}
					>
						<fieldset>
							<RangeControl
								__nextHasNoMarginBottom={true}
								label={__("Height", "wpopus")}
								min={1}
								max={500}
								value={attributes.height}
								onChange={(newValue) => {
									setOption("height", parseInt(newValue));
								}}
							/>
						</fieldset>

						<br />
						<fieldset>
							<RangeControl
								__nextHasNoMarginBottom={true}
								label={__("Width", "wpopus")}
								min={1}
								max={1080}
								value={attributes.width}
								onChange={(newValue) => {
									setOption("width", parseInt(newValue));
								}}
							/>
						</fieldset>
					</PanelBody>
				</Panel>
			</InspectorControls>
		</div>
	);
}
